export default "__VITE_ASSET__YI6NaOMM__"